export default __webpack_public_path__ + "static/media/Camera.b35e7929.svg";